// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//     faArrowLeft, faPrint, faEdit, faMapMarkerAlt, faClock, 
//     faPlane, faFilePdf, faCheckCircle, faTimesCircle, 
//     faHotel, faPlaneDeparture, faPlaneArrival, faSuitcase 
// } from '@fortawesome/free-solid-svg-icons';

// const FALLBACK_IMAGE = "https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/package_images/default-package.jpg";

// // Helper to format date/time
// const formatTime = (dateString) => {
//     if (!dateString) return "";
//     return new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// };

// const DMCPackageDetails = () => {
//     const { id } = useParams();
//     const { user, loading: authLoading } = useAuth();
//     const navigate = useNavigate();
    
//     const [pkg, setPkg] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);

//     const fetchPackageDetails = async () => {
//         setIsLoading(true);
//         try {
//             const res = await apiService.getAll(`${config.GETDMCPACKAGEBYID}/${id}`);
//             console.log("Fetched Package Details:", res);
//             if (res) {
//                 setPkg(res);
//             }
//         } catch (error) {
//             console.error("Error fetching package details:", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!authLoading && !user) {
//             navigate("/");
//         } else if (id) {
//             fetchPackageDetails();
//         }
//     }, [id, user, authLoading]);

//     if (authLoading || isLoading) {
//         return (
//             <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
//                 <div className="spinner-border text-primary" role="status"></div>
//             </div>
//         );
//     }

//     if (!pkg) return <div className="text-center mt-5"><h3>Package Not Found</h3></div>;

//     // Logic for Image
//     const displayImage = (pkg.media?.images && pkg.media.images.length > 0) 
//         ? pkg.media.images[0].url 
//         : FALLBACK_IMAGE;

//     // Logic for PDF
//     const pdfUrl = pkg.media?.itineraryPdf?.url;

//     return (
//         <div style={{ background: '#f8f9fa', minHeight: '100vh', paddingBottom: '50px' }}>
//             <Header User={user} activeSection="holidays" />
            
//             <div className="container mt-4">
//                 {/* 1. TOP HEADER ACTIONS */}
//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                     {/* <button className="btn btn-outline-secondary" onClick={() => navigate("/dmcpackageslist")}>
//                         <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back to List
//                     </button> */}
//                     <div className="d-flex gap-2">
//                         <button className="btn btn-info text-white" onClick={() => window.print()}>
//                             <FontAwesomeIcon icon={faPrint} className="me-2" /> Print
//                         </button>
//                         <button 
//                             className="btn btn-primary" 
//                             onClick={() => navigate(pkg.contentType === 2 ? `/dmccreate-pdf?id=${id}` : `/dmcpackagecreate?id=${id}`)}
//                         >
//                             <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit Package
//                         </button>
//                     </div>
//                 </div>

//                 <div className="row">
//                     {/* LEFT COLUMN - MAIN CONTENT */}
//                     <div className="col-lg-8">
                        
//                         {/* 2. HERO IMAGE */}
//                         <div className="card shadow-sm border-0 mb-4 overflow-hidden" style={{ borderRadius: '12px' }}>
//                             <div style={{ height: '350px', position: 'relative' }}>
//                                 <img 
//                                     src={displayImage} 
//                                     alt={pkg.title} 
//                                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                                     onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
//                                 />
//                                 <div style={{ 
//                                     position: 'absolute', bottom: 0, left: 0, right: 0, 
//                                     background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', 
//                                     padding: '20px', color: 'white' 
//                                 }}>
//                                     <h2 className="fw-bold mb-1 text-white">{pkg.title}</h2>
//                                     <div className="d-flex align-items-center gap-3 text-light opacity-75">
//                                         <span><FontAwesomeIcon icon={faMapMarkerAlt} /> {pkg.destinations?.[0]?.countryName || "DMC Package"}</span>
//                                         <span><FontAwesomeIcon icon={faClock} /> {pkg.totalNights} Nights / {pkg.totalDays} Days</span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* 3. DESCRIPTION & OVERVIEW */}
//                         <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
//                             <h5 className="fw-bold text-primary mb-3">Package Overview</h5>
//                             <p className="text-muted" style={{ whiteSpace: 'pre-line' }}>{pkg.description || "No description provided."}</p>
                            
//                             {pkg.contentType === 2 && (
//                                 <div className="alert alert-light border-primary d-flex align-items-center mt-3">
//                                     <FontAwesomeIcon icon={faFilePdf} className="text-danger fa-2x me-3" />
//                                     <div className="flex-grow-1">
//                                         <h6 className="mb-0 fw-bold">Download Package Flyer</h6>
//                                         <small className="text-muted">This package is a PDF-based itinerary.</small>
//                                     </div>
//                                     {pdfUrl ? (
//                                         <a href={pdfUrl} target="_blank" rel="noreferrer" className="btn btn-danger">Download PDF</a>
//                                     ) : (
//                                         <span className="text-muted small">No PDF Attached</span>
//                                     )}
//                                 </div>
//                             )}
//                         </div>

//                         {/* 4. FLIGHT DETAILS (If Included) */}
//                         {pkg.flights?.included && pkg.flights.options?.length > 0 && (
//                             <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
//                                 <h5 className="fw-bold text-primary mb-3"><FontAwesomeIcon icon={faPlane} /> Flight Details</h5>
//                                 {pkg.flights.options.map((opt, i) => (
//                                     <div key={i} className="mb-3 border rounded p-3 bg-light">
//                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                             <strong>{opt.airline} <span className="badge bg-secondary ms-2">{opt.cabin}</span></strong>
//                                             {/* Optional: Show price if needed */}
//                                             {/* <span className="text-success fw-bold">{pkg.pricing.currency} {opt.pricePerPerson}</span> */}
//                                         </div>
//                                         {opt.segments?.map((seg, j) => (
//                                             <div key={j} className="d-flex align-items-center justify-content-between small text-muted border-top pt-2 mt-2">
//                                                 <div className="d-flex align-items-center gap-2">
//                                                     <span className="fw-bold text-dark">{seg.flightNo}</span>
//                                                     <span>{seg.from} <FontAwesomeIcon icon={faPlaneDeparture} /></span>
//                                                     <span>{formatTime(seg.departureTime)}</span>
//                                                 </div>
//                                                 <div className="text-center" style={{flex: 1, borderBottom: '1px dashed #ccc', margin: '0 10px'}}></div>
//                                                 <div className="d-flex align-items-center gap-2">
//                                                     <span>{formatTime(seg.arrivalTime)}</span>
//                                                     <span><FontAwesomeIcon icon={faPlaneArrival} /> {seg.to}</span>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 ))}
//                             </div>
//                         )}

//                         {/* 5. ACCOMMODATION / HOTELS */}
//                         {pkg.destinations?.length > 0 && (
//                             <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
//                                 <h5 className="fw-bold text-primary mb-3"><FontAwesomeIcon icon={faHotel} /> Accommodation</h5>
//                                 {pkg.destinations.map((dest, i) => (
//                                     <div key={i} className="mb-3">
//                                         <h6 className="fw-bold text-dark border-bottom pb-2">{dest.countryName}</h6>
//                                         {dest.places?.map((place, j) => (
//                                             <div key={j} className="ms-3 mb-3">
//                                                 <div className="d-flex align-items-center gap-2 mb-2">
//                                                     <span className="badge bg-info">{place.cityName}</span>
//                                                     <span className="text-muted small">({place.nights} Nights)</span>
//                                                 </div>
//                                                 {place.hotels?.length > 0 ? (
//                                                     <div className="row g-2">
//                                                         {place.hotels.map((hotel, k) => (
//                                                             <div key={k} className="col-12">
//                                                                 {hotel.hotelOptions?.map((opt, l) => (
//                                                                     <div key={l} className="d-flex align-items-center justify-content-between bg-white border rounded p-2">
//                                                                         <div>
//                                                                             <strong>{opt.name || "Hotel Name TBD"}</strong>
//                                                                             <div className="small text-muted">{opt.roomType} | {opt.mealPlan}</div>
//                                                                         </div>
//                                                                         <div className="text-warning">
//                                                                             {"★".repeat(hotel.hotelCategory || 3)}
//                                                                         </div>
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 ) : <p className="small text-muted fst-italic">No specific hotels listed.</p>}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 ))}
//                             </div>
//                         )}

//                         {/* 6. DAY-BY-DAY ITINERARY */}
//                         {pkg.contentType === 1 && pkg.itinerary && pkg.itinerary.length > 0 && (
//                             <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
//                                 <h5 className="fw-bold text-primary mb-4"><FontAwesomeIcon icon={faMapMarkerAlt} /> Itinerary</h5>
//                                 <div className="timeline">
//                                     {pkg.itinerary.map((day, index) => (
//                                         <div key={index} className="d-flex mb-4">
//                                             <div className="me-3 text-center">
//                                                 <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" 
//                                                      style={{ width: '40px', height: '40px', flexShrink: 0 }}>
//                                                     {day.day}
//                                                 </div>
//                                                 {index !== pkg.itinerary.length - 1 && <div style={{ width: '2px', height: '100%', background: '#e9ecef', margin: '0 auto' }}></div>}
//                                             </div>
//                                             <div className="flex-grow-1">
//                                                 <h6 className="fw-bold mb-1">Day {day.day}: {day.title}</h6>
//                                                 {day.cityName && <small className="text-muted d-block mb-2"><FontAwesomeIcon icon={faMapMarkerAlt} /> {day.cityName}</small>}
//                                                 <p className="text-muted small mb-0">{day.description}</p>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         )}

//                         {/* 7. INCLUSIONS & EXCLUSIONS */}
//                         {(pkg.inclusions?.length > 0 || pkg.exclusions?.length > 0) && (
//                             <div className="row">
//                                 <div className="col-md-6 mb-4">
//                                     <div className="card shadow-sm border-0 h-100 p-4" style={{ borderRadius: '12px' }}>
//                                         <h6 className="fw-bold text-success mb-3"><FontAwesomeIcon icon={faCheckCircle} /> Inclusions</h6>
//                                         <ul className="list-unstyled mb-0">
//                                             {pkg.inclusions?.map((inc, i) => (
//                                                 <li key={i} className="mb-2 text-muted small d-flex align-items-start">
//                                                     <span className="me-2">✓</span> {inc}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6 mb-4">
//                                     <div className="card shadow-sm border-0 h-100 p-4" style={{ borderRadius: '12px' }}>
//                                         <h6 className="fw-bold text-danger mb-3"><FontAwesomeIcon icon={faTimesCircle} /> Exclusions</h6>
//                                         <ul className="list-unstyled mb-0">
//                                             {pkg.exclusions?.map((exc, i) => (
//                                                 <li key={i} className="mb-2 text-muted small d-flex align-items-start">
//                                                     <span className="me-2">✗</span> {exc}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* RIGHT COLUMN - SIDEBAR */}
//                     <div className="col-lg-4">
                        
//                         {/* PRICE CARD */}
//                         <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px', background: '#fff', position: 'sticky', top: '20px' }}>
//                             <h5 className="fw-bold mb-3">Package Pricing</h5>
                            
//                             {/* Land Only */}
//                             <div className="mb-3">
//                                 <span className="badge bg-light text-dark mb-2 border">Land Only</span>
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <span className="text-muted small">Per Person (Double)</span>
//                                     <h4 className="text-primary fw-bold mb-0">
//                                         {pkg.pricing?.currency} {pkg.pricing?.landOnly?.double?.toLocaleString() || "N/A"}
//                                     </h4>
//                                 </div>
//                             </div>

//                             <hr />

//                             {/* With Flight (if applicable) */}
//                             {pkg.pricing?.withFlight?.double > 0 && (
//                                 <div className="mb-3">
//                                     <span className="badge bg-light text-dark mb-2 border">With Flight</span>
//                                     <div className="d-flex justify-content-between align-items-center">
//                                         <span className="text-muted small">Per Person (Double)</span>
//                                         <h4 className="text-success fw-bold mb-0">
//                                             {pkg.pricing?.currency} {pkg.pricing?.withFlight?.double?.toLocaleString()}
//                                         </h4>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Flight Status */}
//                             <div className="mt-3 bg-light p-3 rounded d-flex align-items-center gap-3">
//                                 <div className={`p-2 rounded-circle ${pkg.flights?.included ? 'bg-success text-white' : 'bg-secondary text-white'}`}>
//                                     <FontAwesomeIcon icon={faPlane} />
//                                 </div>
//                                 <div>
//                                     <div className="small fw-bold">Flight Status</div>
//                                     <div className="small text-muted">{pkg.flights?.included ? "Included in Package" : "Not Included"}</div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* COMPANY INFO */}
//                         <div className="card shadow-sm border-0 p-4 mt-4" style={{ borderRadius: '12px' }}>
//                             <small className="text-muted text-uppercase fw-bold">Published By</small>
//                             <h5 className="fw-bold mt-1 text-dark">{pkg.companyName}</h5>
//                             <p className="small text-muted mb-0">Contact the DMC for booking inquiries.</p>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DMCPackageDetails;

// original code changed on 23-03



import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faArrowLeft, faPrint, faEdit, faMapMarkerAlt, faClock, 
    faPlane, faFilePdf, faCheckCircle, faTimesCircle, 
    faHotel, faPlaneDeparture, faPlaneArrival, faSuitcase 
} from '@fortawesome/free-solid-svg-icons';

const FALLBACK_IMAGE = "https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/package_images/default-package.jpg";

const formatTime = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const DMCPackageDetails = () => {
    const { id } = useParams();
    const { user, loading: authLoading } = useAuth();
    const navigate = useNavigate();
    
    const [pkg, setPkg] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchPackageDetails = async () => {
        setIsLoading(true);
        try {
            const res = await apiService.getAll(`${config.GETDMCPACKAGEBYID}/${id}`);
            if (res) {
                setPkg(res);
            }
        } catch (error) {
            console.error("Error fetching package details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!authLoading && !user) {
            navigate("/");
        } else if (id) {
            fetchPackageDetails();
        }
    }, [id, user, authLoading]);

    if (authLoading || isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );
    }

    if (!pkg) return <div className="text-center mt-5"><h3>Package Not Found</h3></div>;

    const displayImage = (pkg.media?.images && pkg.media.images.length > 0) 
        ? pkg.media.images[0].url 
        : FALLBACK_IMAGE;

    const pdfUrl = pkg.media?.itineraryPdf?.url;

    return (
        <div style={{ background: '#f8f9fa', minHeight: '100vh', paddingBottom: '50px' }}>
            {/* CSS for Professional Printing */}
            <style>
                {`
                    @media print {
                        /* 1. Hide Navigation Header and Buttons */
                        header, .no-print, .btn, .navbar {
                            display: none !important;
                        }

                        /* 2. Remove Browser Headers/Footers (URL, Date, Title) */
                        @page {
                            margin: 0; /* This removes the browser's default header/footer text */
                        }
                        
                        body {
                            margin: 0;
                            padding: 1.5cm; /* Adds clean margin inside the page */
                            background-color: white !important;
                            -webkit-print-color-adjust: exact;
                        }

                        .container {
                            width: 100% !important;
                            max-width: 100% !important;
                            margin: 0 !important;
                            padding: 0 !important;
                        }

                        /* 3. Professional Card Adjustments */
                        .card {
                            border: 1px solid #eee !important;
                            box-shadow: none !important;
                            break-inside: avoid; /* Prevents splitting cards across pages */
                            margin-bottom: 20px !important;
                        }

                        .row {
                            display: flex !important;
                            flex-direction: row !important;
                        }

                        .col-lg-8 { width: 65% !important; }
                        .col-lg-4 { width: 35% !important; }

                        /* Ensure background colors show up in PDF */
                        .bg-primary { background-color: #007bff !important; color: white !important; }
                        .bg-light { background-color: #f8f9fa !important; border: 1px solid #ddd !important; }
                        
                        /* Fix for sticky sidebar during print */
                        .sticky-top {
                            position: static !important;
                        }
                    }
                `}
            </style>

            {/* Header - Class 'no-print' added to wrapper to ensure it hides */}
            <div className="no-print">
                <Header User={user} activeSection="holidays" />
            </div>
            
            <div className="container mt-4">
                {/* TOP HEADER ACTIONS - Hidden on Print */}
                <div className="d-flex justify-content-between align-items-center mb-4 no-print">
                    <div></div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-info text-white" onClick={() => window.print()}>
                            <FontAwesomeIcon icon={faPrint} className="me-2" /> Print / Save as PDF
                        </button>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => navigate(pkg.contentType === 2 ? `/dmccreate-pdf?id=${id}` : `/dmcpackagecreate?id=${id}`)}
                        >
                            <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit Package
                        </button>
                    </div>
                </div>

                <div className="row">
                    {/* LEFT COLUMN - MAIN CONTENT */}
                    <div className="col-lg-8">
                        
                        {/* HERO IMAGE */}
                        <div className="card shadow-sm border-0 mb-4 overflow-hidden" style={{ borderRadius: '12px' }}>
                            <div style={{ height: '350px', position: 'relative' }}>
                                <img 
                                    src={displayImage} 
                                    alt={pkg.title} 
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
                                />
                                <div style={{ 
                                    position: 'absolute', bottom: 0, left: 0, right: 0, 
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', 
                                    padding: '20px', color: 'white' 
                                }}>
                                    <h2 className="fw-bold mb-1 text-white">{pkg.title}</h2>
                                    <div className="d-flex align-items-center gap-3 text-light opacity-75">
                                        <span><FontAwesomeIcon icon={faMapMarkerAlt} /> {pkg.destinations?.[0]?.countryName || "DMC Package"}</span>
                                        <span><FontAwesomeIcon icon={faClock} /> {pkg.totalNights} Nights / {pkg.totalDays} Days</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* DESCRIPTION & OVERVIEW */}
                        <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
                            <h5 className="fw-bold text-primary mb-3">Package Overview</h5>
                            <p className="text-muted" style={{ whiteSpace: 'pre-line' }}>{pkg.description || "No description provided."}</p>
                            
                            {pkg.contentType === 2 && (
                                <div className="alert alert-light border-primary d-flex align-items-center mt-3 no-print">
                                    <FontAwesomeIcon icon={faFilePdf} className="text-danger fa-2x me-3" />
                                    <div className="flex-grow-1">
                                        <h6 className="mb-0 fw-bold">Download Package Flyer</h6>
                                        <small className="text-muted">This package is a PDF-based itinerary.</small>
                                    </div>
                                    {pdfUrl ? (
                                        <a href={pdfUrl} target="_blank" rel="noreferrer" className="btn btn-danger">Download PDF</a>
                                    ) : (
                                        <span className="text-muted small">No PDF Attached</span>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* FLIGHT DETAILS */}
                        {pkg.flights?.included && pkg.flights.options?.length > 0 && (
                            <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
                                <h5 className="fw-bold text-primary mb-3"><FontAwesomeIcon icon={faPlane} /> Flight Details</h5>
                                {pkg.flights.options.map((opt, i) => (
                                    <div key={i} className="mb-3 border rounded p-3 bg-light">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <strong>{opt.airline} <span className="badge bg-secondary ms-2">{opt.cabin}</span></strong>
                                        </div>
                                        {opt.segments?.map((seg, j) => (
                                            <div key={j} className="d-flex align-items-center justify-content-between small text-muted border-top pt-2 mt-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className="fw-bold text-dark">{seg.flightNo}</span>
                                                    <span>{seg.from} <FontAwesomeIcon icon={faPlaneDeparture} /></span>
                                                    <span>{formatTime(seg.departureTime)}</span>
                                                </div>
                                                <div className="text-center" style={{flex: 1, borderBottom: '1px dashed #ccc', margin: '0 10px'}}></div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span>{formatTime(seg.arrivalTime)}</span>
                                                    <span><FontAwesomeIcon icon={faPlaneArrival} /> {seg.to}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* ACCOMMODATION */}
                        {pkg.destinations?.length > 0 && (
                            <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
                                <h5 className="fw-bold text-primary mb-3"><FontAwesomeIcon icon={faHotel} /> Accommodation</h5>
                                {pkg.destinations.map((dest, i) => (
                                    <div key={i} className="mb-3">
                                        <h6 className="fw-bold text-dark border-bottom pb-2">{dest.countryName}</h6>
                                        {dest.places?.map((place, j) => (
                                            <div key={j} className="ms-3 mb-3">
                                                <div className="d-flex align-items-center gap-2 mb-2">
                                                    <span className="badge bg-info">{place.cityName}</span>
                                                    <span className="text-muted small">({place.nights} Nights)</span>
                                                </div>
                                                {place.hotels?.length > 0 ? (
                                                    <div className="row g-2">
                                                        {place.hotels.map((hotel, k) => (
                                                            <div key={k} className="col-12">
                                                                {hotel.hotelOptions?.map((opt, l) => (
                                                                    <div key={l} className="d-flex align-items-center justify-content-between bg-white border rounded p-2 mb-1">
                                                                        <div>
                                                                            <strong>{opt.name || "Hotel Name TBD"}</strong>
                                                                            <div className="small text-muted">{opt.roomType} | {opt.mealPlan}</div>
                                                                        </div>
                                                                        <div className="text-warning">
                                                                            {"★".repeat(hotel.hotelCategory || 3)}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : <p className="small text-muted fst-italic">No specific hotels listed.</p>}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* DAY-BY-DAY ITINERARY */}
                        {pkg.contentType === 1 && pkg.itinerary && pkg.itinerary.length > 0 && (
                            <div className="card shadow-sm border-0 mb-4 p-4" style={{ borderRadius: '12px' }}>
                                <h5 className="fw-bold text-primary mb-4"><FontAwesomeIcon icon={faMapMarkerAlt} /> Itinerary</h5>
                                <div className="timeline">
                                    {pkg.itinerary.map((day, index) => (
                                        <div key={index} className="d-flex mb-4" style={{ breakInside: 'avoid' }}>
                                            <div className="me-3 text-center">
                                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" 
                                                     style={{ width: '40px', height: '40px', flexShrink: 0 }}>
                                                    {day.day}
                                                </div>
                                                {index !== pkg.itinerary.length - 1 && <div style={{ width: '2px', height: '100%', background: '#e9ecef', margin: '0 auto' }}></div>}
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="fw-bold mb-1">Day {day.day}: {day.title}</h6>
                                                {day.cityName && <small className="text-muted d-block mb-2"><FontAwesomeIcon icon={faMapMarkerAlt} /> {day.cityName}</small>}
                                                <p className="text-muted small mb-0">{day.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* INCLUSIONS & EXCLUSIONS */}
                        {(pkg.inclusions?.length > 0 || pkg.exclusions?.length > 0) && (
                            <div className="row">
                                <div className="col-md-6 mb-4">
                                    <div className="card shadow-sm border-0 h-100 p-4" style={{ borderRadius: '12px' }}>
                                        <h6 className="fw-bold text-success mb-3"><FontAwesomeIcon icon={faCheckCircle} /> Inclusions</h6>
                                        <ul className="list-unstyled mb-0">
                                            {pkg.inclusions?.map((inc, i) => (
                                                <li key={i} className="mb-2 text-muted small d-flex align-items-start">
                                                    <span className="me-2 text-success">✓</span> {inc}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4">
                                    <div className="card shadow-sm border-0 h-100 p-4" style={{ borderRadius: '12px' }}>
                                        <h6 className="fw-bold text-danger mb-3"><FontAwesomeIcon icon={faTimesCircle} /> Exclusions</h6>
                                        <ul className="list-unstyled mb-0">
                                            {pkg.exclusions?.map((exc, i) => (
                                                <li key={i} className="mb-2 text-muted small d-flex align-items-start">
                                                    <span className="me-2 text-danger">✗</span> {exc}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* RIGHT COLUMN - SIDEBAR */}
                    <div className="col-lg-4">
                        
                        {/* PRICE CARD */}
                        <div className="card shadow-sm border-0 mb-4 p-4 sticky-top" style={{ borderRadius: '12px', background: '#fff', top: '20px' }}>
                            <h5 className="fw-bold mb-3">Package Pricing</h5>
                            
                            <div className="mb-3">
                                <span className="badge bg-light text-dark mb-2 border">Land Only</span>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted small">Per Person (Double)</span>
                                    <h4 className="text-primary fw-bold mb-0">
                                        {pkg.pricing?.currency} {pkg.pricing?.landOnly?.double?.toLocaleString() || "N/A"}
                                    </h4>
                                </div>
                            </div>

                            <hr />

                            {pkg.pricing?.withFlight?.double > 0 && (
                                <div className="mb-3">
                                    <span className="badge bg-light text-dark mb-2 border">With Flight</span>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="text-muted small">Per Person (Double)</span>
                                        <h4 className="text-success fw-bold mb-0">
                                            {pkg.pricing?.currency} {pkg.pricing?.withFlight?.double?.toLocaleString()}
                                        </h4>
                                    </div>
                                </div>
                            )}

                            <div className="mt-3 bg-light p-3 rounded d-flex align-items-center gap-3">
                                <div className={`p-2 rounded-circle ${pkg.flights?.included ? 'bg-success text-white' : 'bg-secondary text-white'}`}>
                                    <FontAwesomeIcon icon={faPlane} />
                                </div>
                                <div>
                                    <div className="small fw-bold">Flight Status</div>
                                    <div className="small text-muted">{pkg.flights?.included ? "Included in Package" : "Not Included"}</div>
                                </div>
                            </div>
                        </div>

                        {/* COMPANY INFO */}
                        <div className="card shadow-sm border-0 p-4 mt-4" style={{ borderRadius: '12px' }}>
                            <small className="text-muted text-uppercase fw-bold">Published By</small>
                            <h5 className="fw-bold mt-1 text-dark">{pkg.companyName}</h5>
                            <p className="small text-muted mb-0">Contact the DMC for booking inquiries.</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default DMCPackageDetails;